import * as types from './entryQualificationAwarded.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_ENTRY_QUALIFICATION_AWARDED,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_ENTRY_QUALIFICATION_AWARDED,
		payload,
	}),
	get: payload => ({
		type: types.GET_ENTRY_QUALIFICATION_AWARDED,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_ENTRY_QUALIFICATION_AWARDED,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_ENTRY_QUALIFICATION_AWARDED,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setErrors: payload => ({
		type: types.SET_ERRORS,
		payload,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
